// Application entry point.
// Mounts <App /> into <div id="root"> in index.html.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

// Global styles. Loaded once here so every component sees them — we don't
// need per-component CSS-in-JS or CSS Modules for this small app.
import './styles/main.scss';

// document.getElementById can return null, so we assert non-null with `!`.
// If #root is missing, that's a build-config error not a runtime concern.
const rootElement = document.getElementById('root')!;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {/* BrowserRouter is fine because every host worth deploying to supports
        HTML5 history mode. If you ever deploy somewhere that can't do
        URL rewrites (e.g. some basic shared hosting), switch to HashRouter. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
